<div
  class="bn-dialog bn-shield-upgrade-modal p-2 pb-0"
  [ngClass]="{
    'bn-shield-upgrade-modal--success': showSuccessScreen(),
  }">
  <div
    class="bn-dialog__close"
    (click)="onClose()">
    <fa-icon
      aria-label="Close"
      icon="xmark"
      size="lg" />
  </div>
  <div class="bn-dialog__body">
    @if (showSuccessScreen()) {
      <div class="text-center">
        <div class="bn-shield-upgrade-modal__title pb-2">Congratulations!</div>
        <div class="bn-shield-upgrade-modal__text mb-4">Your plan was succesfully upgraded.</div>
        <img
          class="bn-shield-upgrade-modal__image mb-6"
          src="/assets/web-ui/images/bunny-bunnyman.svg" />
      </div>
    }
    @if (!showSuccessScreen()) {
      <div class="row">
        <div class="col-6 d-none d-md-flex flex-column text-center">
          <div
            class="bn-shield-upgrade-modal__title ms-6"
            [innerHtml]="data?.title"></div>
          <div class="flex-grow-1 align-items-center justify-content-center d-flex">
            <img
              class="bn-shield-upgrade-modal__image"
              height="375px"
              src="/assets/web-ui/images/bunny-shield.svg" />
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div
            class="bn-shield-upgrade-modal__title d-block d-md-none text-center text-md-left ms-md-6"
            [innerHtml]="data?.extra?.title"></div>
          <div class="bn-shield-upgrade-modal__content">
            <div
              class="bn-shield-upgrade-modal__content__title"
              [innerHtml]="data?.extra?.title"></div>
            <p [innerHtml]="data?.extra?.description"></p>
            <div class="row">
              <div class="text-dark-8 text-500-medium mb-2 mt-4">Here’s what you unlock:</div>
              @if (listData) {
                <bn-web-ui-list-with-icon [data]="listData" />
              }
            </div>
            <div class="bn-dialog__actions">
              <button
                bn-web-ui-button
                size="lg"
                [fullWidth]="true"
                [itemStyle]="(requiredPlan || 0) < PlanType.Enterprise ? 'primary' : 'stroke'"
                [loading]="isLoading()"
                (click)="onUpgrade(requiredPlan)">
                @if (requiredPlan === PlanType.Enterprise) {
                  Contact Sales
                } @else {
                  No More Bad Bunnies. Go {{ PlanType[requiredPlan ?? 0] }}.
                }
              </button>
            </div>
            <div class="text-center mt-2">
              @if (requiredPlan === PlanType.Advanced) {
                Advanced is $9.50/mo
              }
              @if (requiredPlan === PlanType.Business) {
                Business is $99/mo
              }
            </div>
            @if (isError()) {
              <bn-web-ui-alert
                alertType="danger"
                class="text-start mt-2"
                headerIcon="circle-exclamation"
                [showIcon]="true">
                Something went wrong, please try later!
              </bn-web-ui-alert>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
